import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useOrdersRealtime = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    console.log("[useOrdersRealtime] Setting up realtime subscription");

    const channel = supabase
      .channel("orders-live-realtime")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "orders_live_ls",
        },
        (payload) => {
          console.log("[useOrdersRealtime] Change received:", payload.eventType);
          
          // Invalidate both orders and stats queries
          queryClient.invalidateQueries({ queryKey: ["orders"] });
          queryClient.invalidateQueries({ queryKey: ["orders-stats"] });
        }
      )
      .subscribe((status) => {
        console.log("[useOrdersRealtime] Subscription status:", status);
      });

    return () => {
      console.log("[useOrdersRealtime] Cleaning up subscription");
      supabase.removeChannel(channel);
    };
  }, [queryClient]);
};
